<template>
  <div class="vaultAboutContainer w-100">
    <MarketingRow
      :backgroundColor="vaultAboutContent.top.backgroundColor"
      :body="vaultAboutContent.top.body"
      :bodyIsHTML="vaultAboutContent.top.bodyIsHTML"
      :noAssetBackground="vaultAboutContent.top.noAssetBackground"
      :textSide="vaultAboutContent.top.textSide"
      :title="vaultAboutContent.top.title"
      :titleType="vaultAboutContent.top.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="vaultAboutContent.top.title.join(' ')"
          :class="{ overflowImage: vaultAboutContent.top.overflowImage, 'contain': vaultAboutContent.top.containImage }"
          :src="!isMobile ? vaultAboutContent.top.imageUrlDesktop : vaultAboutContent.top.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <StatsRow />
    <MarketingRow
      :backgroundColor="vaultAboutContent.middle.backgroundColor"
      :body="vaultAboutContent.middle.body"
      :bodyIsHTML="vaultAboutContent.middle.bodyIsHTML"
      :noAssetBackground="vaultAboutContent.middle.noAssetBackground"
      :textSide="vaultAboutContent.middle.textSide"
      :title="vaultAboutContent.middle.title"
      :titleType="vaultAboutContent.middle.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="vaultAboutContent.middle.title.join(' ')"
          :class="{ overflowImage: vaultAboutContent.middle.overflowImage, 'contain': vaultAboutContent.middle.containImage }"
          :src="!isMobile ? vaultAboutContent.middle.imageUrlDesktop : vaultAboutContent.middle.imageUrlMobile"
        />
      </template>
    </MarketingRow>

    <VaultFeesRow />

    <MarketingRow
      v-for="(
        {
          backgroundColor,
          body,
          containImage,
          textSide,
          title,
          titleType,
          noAssetBackground,
          overflowImage,
          imageUrlDesktop,
          imageUrlMobile
        }, index
      ) in vaultAboutContent.main"
      :key="`main-${index}`"
      :backgroundColor="backgroundColor"
      :body="body"
      :noAssetBackground="noAssetBackground"
      :textSide="textSide"
      :title="title"
      :titleType="titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="title.join(' ')"
          :class="{ overflowImage: overflowImage, 'contain': containImage }"
          :src="!isMobile ? imageUrlDesktop : imageUrlMobile"
        />
      </template>
    </MarketingRow>
  </div>
</template>

<script>
import { BImgLazy } from 'bootstrap-vue';
import VaultFeesRow from './VaultFeesRow.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import StatsRow from '../../homepage/components/StatsRow.vue';
import { vaultAboutContent } from '../constants/vaultConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'VaultAbout',
  components: {
    BImgLazy,
    MarketingRow,
    StatsRow,
    VaultFeesRow,
  },
  mixins: [baseIsMobile],
  data() {
    return {
      vaultAboutContent,
    };
  }
};
</script>
